<template>
  <div v-if="show" :class="[floor.$row, floor.$style]">
    <div
      :class="['goods', `goods-${item.$status}`]"
      v-for="(item, index) of items"
      :key="item.id"
      @click="onJumpTo(item, index)"
    >
      <div class="item">
        <div class="tag" v-if="show.tag">{{ item.$tag }}</div>
        <div class="left">
          <van-image
            class="goods-image"
            :src="item.$coverUrl"
            lazy-load
            fit="cover"
          >
            <template v-slot:loading>
              <img :src="loadingImg" alt="" />
            </template>
            <template v-slot:error>
              <img :src="loadingImg" alt="" />
            </template>
          </van-image>
        </div>
        <div class="right">
          <div class="name">
            {{ item.seckillGoodsVO.seckillGoodsName }}
          </div>
          <div class="desc">{{ item.seckillGoodsVO.sellProp }}</div>
          <div class="progress-box" v-if="item.$percentage">
            <div class="stock" v-if="show.right.stock">{{ item.$stock }}</div>
            <div class="progress">
              <div class="inner" :style="{ width: `${item.$percentage}` }" />
            </div>
            <div class="percentage" v-if="show.right.percentage">
              {{ item.$percentage }}
            </div>
          </div>
          <div class="view1">
            <div class="price" v-if="show.right.price">
              <div class="value">￥{{ item.$price }}</div>
              <div
                class="marking-price"
                v-if="show.right.markingPrice && item.$markingPrice"
              >
                ￥{{ item.$markingPrice }}
              </div>
            </div>
            <div
              v-if="item.$btn"
              :class="['btn', item.$btn.class]"
              @click.stop="onButtonClick(item, index)"
            >
              <div class="tag" v-if="show.right.tag && item.$tag">
                {{ item.$tag }}
              </div>
              {{ item.$btn.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/utils/axios';
import { Toast } from 'vant';
import { navigateTo } from '@/views/activities/utils';
export default {
  props: {
    home: Object,
    floor: Object
  },
  data() {
    return {
      token: Boolean(sessionStorage.getItem('token')),
      show: undefined,
      items: [],
      loadingImg:
        this.$theme.u_goods_icon_default || require('@/assets/loadingBG.png')
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.unwatch) this.unwatch();
      this.normalizeFloor();
      this.unwatch = this.$watch('floor', this.init);
    },
    normalizeFloor() {
      const { floor, token } = this;
      const row = floor.$row.split('-')[1];
      const style = floor.$style.split('-')[1];
      const { show, button } = this.normalizeShow(row, style);
      const showStatus = {
        1: '已开抢',
        2: '抢购中',
        3: '即将开始'
      };
      const toNumber = (val) => {
        val = Number(val);
        return isNaN(val) ? 0 : val;
      };
      floor.items.forEach((item) => {
        const vo = item.seckillGoodsVO;
        const url = vo.seckillHeadImageKeyUrl || vo.indexImageKeyUrl;
        const status = button.status[vo.buttonStatus];
        const total = toNumber(vo.seckillSkuTotal);
        const current = toNumber(vo.currentStock);
        const hidePrice = vo.switchUserGroup == 1 && vo.isPriceShow != 0;
        let btn = {};
        let price = vo.seckillSalePrice;
        let markingPrice = vo.seckillMarkingPrice;
        let tag = '';
        let stock = '';
        let percentage = '';
        switch (style) {
          case 'one':
            if (!token) {
              btn.class = 'not-login';
              btn.name = '登录后查看';
            } else if (hidePrice) {
              price = '???';
              btn.name = vo.tagText;
              btn.class = 'hide-price';
            } else {
              btn.class = 'is-status';
              btn.name = button.names[vo.buttonStatus];
            }
            tag = `${vo.skShowTimeInfo} ${showStatus[vo.skShowStatus]}`;
            switch (status) {
              case 'started':
              case 'finished':
              case 'over':
                percentage = ((total - current) / total) * 100;
                percentage = `${Math.floor(percentage)}%`;
                break;
            }
            break;
          case 'two':
            if (hidePrice) {
              price = '???';
              btn = null;
            } else {
              btn.name = button.names[vo.buttonStatus];
            }
            switch (status) {
              case 'started':
                percentage = `${Math.floor((current / total) * 100)}%`;
                tag = '进行中';
                stock = `仅剩${current}份`;
                break;
              case 'finished':
              case 'over':
                percentage = '0%';
                stock = '仅剩0份';
                tag = '';
                break;
              default:
                percentage = '100%';
                tag = vo.skShowTimeInfo;
                stock = '即将开始';
                break;
            }
            break;
        }
        if (hidePrice) {
          markingPrice = '';
        }
        this.$set(item, '$tag', tag);
        this.$set(item, '$stock', stock);
        this.$set(item, '$price', price);
        this.$set(item, '$markingPrice', markingPrice);
        this.$set(item, '$status', status);
        this.$set(item, '$percentage', percentage);
        this.$set(item, '$coverUrl', url);
        this.$set(item, '$btn', btn);
      });
      this.show = show;
      this.items = floor.items;
    },
    normalizeShow(row, style) {
      const { floor } = this;
      const display = floor.$display;
      const show = {
        right: {
          price: true
        }
      };
      const button = {
        names: {
          1: '去看看',
          2: '去抢购',
          3: '提醒我',
          4: '取消提醒',
          5: '已结束'
        },
        status: {
          1: 'finished',
          2: 'started',
          3: 'unstart',
          4: 'unstart-reminded',
          5: 'over'
        }
      };
      switch (style) {
        case 'one':
          show.tag = true;
          show.right.price = this.token;
          show.right.percentage = true;
          show.right.markingPrice = true;
          break;
        case 'two':
          button.names[1] = '已领完';
          show.right.stock = display.seckillStock;
          show.right.tag = true;
          show.right.markingPrice = display.seckillMarkingPrice;
          break;
      }
      return { show, button };
    },
    onJumpTo(item, index) {
      const { floor } = this;
      const { goodsId } = item.seckillGoodsVO;
      let type, value;
      switch (floor.goodsLinkType) {
        case 1: // 商品详情页
          type = 3;
          value = goodsId;
          break;
        case 2: // 二级页面
          type = 11;
          value = floor.goodsLinkValue;
          break;
        case 3: // 店铺主页
          type = 4;
          value = item.branchId;
          break;
        case 4: // 品牌首页
          type = 10;
          value = item.branchLogoId;
          break;
        case 5: // 商品详情落地页
          type = 53;
          value = goodsId;
          break;
        case 6: // 店铺主页落地页
          type = 54;
          value = item.branchId;
          break;
      }
      this.uploadClickGio(item, value, index);
      navigateTo(this, {
        pageLinkType: type,
        pageLinkValue: value,
        goodsId
      });
    },
    uploadClickGio(item, value, index) {
      const { home, floor } = this;
      const shared = {
        pageType_var: home.$pageName,
        dataSourceType_var: floor.goodsLinkType,
        dataSourcePageID_var: value
      };
      switch (home.$from) {
        case 'home':
          gio('track', 'flowLocationClick', {
            indexId_var: home.contentPageId,
            entryType_vara: floor.modelTitle,
            entryType_floor_var: floor.$index,
            position_var: index,
            sort_var: '',
            ...shared
          });
          break;
        case 'activity':
          gio('track', 'activityFlowLocationClick_var', {
            secondPageID_var: `${home.contentPageId}`,
            entryType_vara: '秒杀商品',
            entryType_floor_var: floor.$index,
            position_var: index,
            sort_var: '',
            positonName_var: item.seckillGoodsVO.seckillGoodsName,
            shopID_var: 'n', //切换商场ID  ver607 二级页面流量位点击
            belongShop_var: 'n', //归属商场ID
            // belongShop_var:(item&&item.shopId)||"n",  //归属商场ID
            ...shared
          });
          break;
      }
    },
    onButtonClick(item, index) {
      if (item.$status === 'unstart') {
        http({
          url: `order/user/seckill/follow/${item.seckillGoodsId}`,
          method: 'put'
        }).then((rps) => {
          if (rps.code == 200) {
            this.$loading.hide();
            Toast({
              message: '设置成功！将在开抢5分钟前提醒您！',
              duration: 1000
            });
            this.$emit('call', { fn: 'reloadData' });
          }
        });
      } else if (item.$status === 'unstart-reminded') {
        http({
          url: `order/user/seckill/unfollow/${item.seckillGoodsId}`,
          method: 'put'
        }).then((rps) => {
          if (rps.code == 200) {
            this.$loading.hide();
            Toast({
              message: '秒杀提醒已取消，您可能会抢不到哦！',
              duration: 1000
            });
            this.$emit('call', { fn: 'reloadData' });
          }
        });
      } else {
        this.onJumpTo(item, index);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import url('./css/base.less');
@import url('./css/row-one.less');
@import url('./css/row-multiple.less');
</style>
